import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';


export default function CookiePolicyData() {
  const [t, i18next] = useTranslation("global")
  const language = localStorage.getItem('i18nextLng') || 'es'

  return (
    <Paper style={{ margin: '30px 10%' }} elevation={0}>
      <div style={{ textAlign: "justify" }}>
        <p>
          {t(`policy.cookies.description1.1`)}
          <a href={`${t('t(`policy.cookies.url')}`}>
            {t(`policy.cookies.url`)}
          </a>
          {t(`policy.cookies.description1.2`)}
        </p>
        <p>
          {t(`policy.cookies.description2`)}
          <a href={`mailto:${t('t(`policy.cookies.email')}`}>
            {t(`policy.cookies.email`)}
          </a>
          .
        </p>
        <p><strong>{t(`policy.cookies.subTitle`)}</strong></p>
        <p> {t(`policy.cookies.description3`)}</p>
        <p> {t(`policy.cookies.description4`)}</p>
        <p> {t(`policy.cookies.description5`)}</p>
        <p> {t(`policy.cookies.description6`)}</p>
        <p> {t(`policy.cookies.description7`)}</p>
        <p> {t(`policy.cookies.description8`)}</p>
        <p>
          <span style={{ fontStyle: "italic" }}>
            {t(`policy.cookies.description9.1`)}
          </span>
          {t(`policy.cookies.description9.2`)}
        </p>
        <p> {t(`policy.cookies.description10`)}</p>
        <p>
          <strong>{t(`policy.cookies.description11.1`)}</strong>
          {t(`policy.cookies.description11.2`)}
        </p>
        <p>
          <span style={{ fontStyle: "italic" }}>
            {t(`policy.cookies.description12.1`)}
          </span>
          {t(`policy.cookies.description12.2`)}
        </p>
        <p> {t(`policy.cookies.description13`)}</p>
        <ul style={{ listStyleType: 'none' }}>
          <li>{`1. ${t('policy.cookies.description14.1')}`}</li>
          <li>{`2. ${t('policy.cookies.description14.2')}`}</li>
        </ul>


        <p> {t(`policy.cookies.description15`)}</p>
        <p> {t(`policy.cookies.description16`)}</p>
        <p style={{ fontWeight: 'bold' }}>
          <span style={{ fontStyle: "italic" }}>
            {t(`policy.cookies.description17`)}
          </span>
          {t(`policy.cookies.description18`)}
        </p>
        <TableContainer component={Paper} elevation={0} sx={{ width: '100%' }}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableTitle1`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableTitle2`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableTitle3`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableTitle4`)}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription1`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription2`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription3`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription4`)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription5`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription6`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription7`)}</TableCell>
                <TableCell style={{ fontSize: '16px' }} align="left">{t(`policy.cookies.tableDescription8`)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <p>
          <strong>{t(`policy.cookies.description18.1`)}</strong>
          {t(`policy.cookies.description18.2`)}
          <a href={`https://policies.google.com/privacy`} target='_blank'>
            {t(`policy.cookies.description18.3`)}
          </a>
          {t(`policy.cookies.description18.4`)}
        </p>
        <p>
          <strong>{t(`policy.cookies.description19`)}</strong>
        </p>
        <p>{t(`policy.cookies.description20`)}</p>
        <p>{t(`policy.cookies.description21`)}</p>
        <ul style={{ listStyleType: 'none' }}>
          <li>
            <strong>
              {`1. ${t('policy.cookies.browser1')}`}
            </strong>
            {t('policy.cookies.browserDescriptio1')}
            <a href={`https://support.google.com/accounts/answer/61416?hl=es&co=GENIE.Platform%3DDesktop`} target='_blank'>
              {t(`policy.cookies.browserLink1`)}
            </a>
          </li>
          <li>
            <strong>
              {`2. ${t('policy.cookies.browser2')}`}
            </strong>
            {t('policy.cookies.browserDescriptio2')}
            <a href={`https://support.microsoft.com/es-es/windows/administrar-cookies-en-microsoft-edge-ver-permitir-bloquear-eliminar-y-usar-168dab11-0753-043d-7c16-ede5947fc64d`} target='_blank'>
              {t(`policy.cookies.browserLink2`)}
            </a>
          </li>
          <li>
            <strong>
              {`3. ${t('policy.cookies.browser3')}`}
            </strong>
            {t('policy.cookies.browserDescriptio3')}
            <a href={`https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we&redirectlocale=es`} target='_blank'>
              {t(`policy.cookies.browserLink3`)}
            </a>
          </li>
          <li>
            <strong>
              {`4. ${t('policy.cookies.browser4')}`}
            </strong>
            {t('policy.cookies.browserDescriptio4')}
            <a href={`https://support.apple.com/es-es/guide/safari/sfri11471/mac`} target='_blank'>
              {t(`policy.cookies.browserLink4`)}
            </a>
          </li>
        </ul>
        <p>{t(`policy.cookies.description22`)}</p>
        <ul style={{ listStyleType: 'none' }}>
          <li>{`1. ${t('policy.cookies.description22.1')}`}</li>
          <li>{`2. ${t('policy.cookies.description22.2')}`}</li>
          <li>{`3. ${t('policy.cookies.description22.3')}`}</li>
          <li>{`4. ${t('policy.cookies.description22.4')}`}</li>
          <li>{`5. ${t('policy.cookies.description22.5')}`}</li>
        </ul>
        <br />
        <p>{t(`policy.cookies.date`)}</p>
      </div>
    </Paper >
  );
}
